export const DEFAULT_HOST = 'cdn-mr.contentful.com';

export const contentTypeIds = {
  ccpProduct: '5SYgp4uHBcLFL1K0EsCY4l',
  ccpOffering: '31uDFGQ9rMyZpBgP4oexja',
  ccpPricingPlan: '4mPAebkrFzFAhwblQ6PmRx'
};
